import { useState } from "react";
import { Loader2, Send, Check } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";

const KINDS = [["pricing", "Plans & pricing", "Plan table + pricing page"], ["products", "Add-ons & features", "Products page"], ["gift_cards", "eGift cards", "Gift card shop"], ["demo", "Book a demo", "Self-booking link"]];

export const SalesInfoSend = ({ target }) => {
  const [sel, setSel] = useState(["pricing"]);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const tog = (k) => setSel(sel.includes(k) ? sel.filter(x => x !== k) : [...sel, k]);
  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post("/api/callcenter/send-info", { ...target, kinds: sel, note }); (data.partial ? toast.warning : toast.success)(data.message); setNote(""); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="space-y-2" data-testid="qs-info">
      <div className="grid grid-cols-2 gap-1.5">{KINDS.map(([k, l, s]) => (
        <button key={k} onClick={() => tog(k)} className={`text-left p-2 rounded-lg border transition-colors relative ${sel.includes(k) ? "border-blue-600 bg-blue-50" : "border-slate-200 hover:border-blue-300"}`} data-testid={`qs-info-${k}`}>
          <p className="text-sm font-semibold text-slate-900">{l}</p><p className="text-[11px] text-slate-500">{s}</p>
          {sel.includes(k) && <Check className="w-4 h-4 text-blue-600 absolute top-2 right-2" />}
        </button>))}</div>
      <Textarea rows={2} placeholder="Add a personal note (optional)" value={note} onChange={e => setNote(e.target.value)} className="text-sm" data-testid="qs-info-note" />
      <button disabled={!sel.length || !target.channels.length || busy} onClick={send} className="w-full bg-blue-600 hover:bg-blue-500 disabled:opacity-40 text-white font-bold py-2 rounded-lg flex items-center justify-center gap-1.5 text-sm" data-testid="qs-info-send">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}Send sales info</button>
    </div>
  );
};
